import React from 'react'
import { Control } from '../../'

/* doc
---
title: ButtonGroupItem
name: ButtonGroupItem
category: React - Bulma
parent: ButtonGroup
---

A `ButtonGroupItem` is a container for `Button` components that are inside of
a `ButtonGroup` component. multiple buttons. add `isSpaceless` to remove space between buttons.

Each `Button` component should be wrapped with a `ButtonGroupItem` component.

See [Bulma Documentation](http://bulma.io/documentation/elements/button/#button-group) for reference and full options.
If one of the Bulma options isn't listed below, it may be added using the `className` prop.

### Props
| Prop Name       | Description                                   |Type            | Default Value             | Required?     |
|-----------------|-----------------------------------------------|----------------|---------------------------|---------------|
| isSpaceless     | Removes space btween buttons.                 | boolean        | false                     | no            |

```html_example
  <ButtonGroup isSpaceless>
    <ButtonGroupItem>
      <PrimaryButton>...</PrimaryButton>
    <ButtonGroupItem>
    <ButtonGroupItem>
      <ErrorButton>...</ErrorButton>
    <ButtonGroupItem>
  </ButtonGroup>
```
*/
function ButtonGroupItem(props) {
  const { children, ...rest } = props

  return (
    <Control {...rest}>
      {children}
    </Control>
  )
}

export default ButtonGroupItem
